import React, { useState } from 'react';
export default function Prompt({
  text
}) {
  const [message, setMessage] = useState('');
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setMessage('Copied');
    } catch {
      setMessage('Select the text below and copy it manually.');
    }
  };
  return <section className="ss-panel"><button type="button" onClick={copy}>Copy prompt</button> <span role="status">{message}</span><textarea aria-label="Standardized prompt" rows={10} readOnly value={text || ''} /></section>;
}
